var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.anbieter},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{on:{"click":function($event){return _vm.anbieterEdit(item.id)}}},[_vm._v("mdi-pencil")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }